import { useState } from 'react';
import { supabase } from '@/api/supabaseClient';
import { toast } from 'sonner';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Lock } from 'lucide-react';

// Shared "change my own password" card -- works for any signed-in user
// (driver or staff) since it's a Supabase Auth action independent of
// DriverProfile/StaffProfile. Used by DriverProfile.jsx for both the
// driver and staff branches of /my-profile.
export default function AccountSecurityCard() {
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [saving, setSaving] = useState(false);

  const handleChangePassword = async () => {
    if (password.length < 8) { toast.error('Password must be at least 8 characters.'); return; }
    if (password !== confirm) { toast.error('Passwords do not match.'); return; }
    setSaving(true);
    try {
      const { error } = await supabase.auth.updateUser({ password });
      if (error) throw error;
      toast.success('Password updated.');
      setPassword('');
      setConfirm('');
    } catch (e) {
      toast.error(e?.message || 'Could not update password.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="glass-card p-6 space-y-4">
      <div className="flex items-center gap-3 pb-3 border-b border-border">
        <div className="w-8 h-8 rounded-lg bg-primary/10 flex items-center justify-center">
          <Lock className="w-4 h-4 text-primary" />
        </div>
        <h3 className="font-space font-semibold text-foreground">Change Password</h3>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div>
          <label className="text-xs text-muted-foreground block mb-1">New Password</label>
          <Input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="••••••••"
            minLength={8}
            autoComplete="new-password"
            className="text-foreground"
          />
        </div>
        <div>
          <label className="text-xs text-muted-foreground block mb-1">Confirm Password</label>
          <Input
            type="password"
            value={confirm}
            onChange={e => setConfirm(e.target.value)}
            placeholder="••••••••"
            minLength={8}
            autoComplete="new-password"
            className="text-foreground"
          />
        </div>
      </div>
      <div className="flex justify-end">
        <Button onClick={handleChangePassword} disabled={saving} className="bg-primary text-primary-foreground">
          {saving ? 'Updating…' : 'Update Password'}
        </Button>
      </div>
    </div>
  );
}
